<template>
  <div class="col-12 col-lg-6">
    <extra-equipment-group
      v-for="eachGroup in groups"
      :key="eachGroup.group"
      :group="eachGroup"
    />
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import ExtraEquipmentGroup from './ExtraEquipmentGroup';

  @Component({
    components: {ExtraEquipmentGroup}
  })
  export default class ExtraEquipmentColumn extends Vue {
    @Prop(Array) groups;
  }
</script>
